import CountryFlag from '@/components/icons/CountryFlag';

export function _renderStringAsFlag(num, iso2) {
    if (!num || num === '+') {
        return <span style={{ fontSize: '16px' }}>🌐</span>;
    }
    if (iso2) {
        return (
            <CountryFlag
                countryCode={iso2}
                size={14}
                style={{ border: '1px solid #CBD5E0' }}
            />
        );
    }
    return undefined;
}
